import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AzureAwsSwitchService } from "../azure-aws-switch.service";
import { AuthMode } from "../../../environments/environment";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private azureAws: AzureAwsSwitchService
  ) {}

  ngOnInit() {
    console.log("AUTH: Login");
    if (localStorage.getItem("adal.error") == "access_denied") {
      // Not having access
      this.router.navigate(["/loginerrorpage"], { skipLocationChange: true });
    } else if (this.azureAws.isLogged) {
      const returnUrl = this.route.snapshot.queryParams["returnUrl"]
        ? decodeURI(this.route.snapshot.queryParams["returnUrl"])
        : "/";
      console.log("AUTH: Login-" + returnUrl);
      if (this.azureAws.currentAuthMode === AuthMode.Azure) {
        this.router.navigateByUrl(returnUrl);
      }
    } else {
      console.log("AUTH: Login-call AdalSvc");
      //this.adalSrv.context.login();
      this.azureAws.login();
    }
  }
}
